module.exports = __webpack_public_path__ + "img/jennifer_gibson_expert_exchanges_credit_likhaan_2.a8f8db59.jpg";